import React from "react";
import Valerion from "../assets/Images/pdffile/VALERION MGT-7A_09_11_2025_signed.pdf.pdf";

const coporateDate = [
  {
    title: "Financial Year 2024-2025",
    img: Valerion,   // FIXED
    des: "",
  },
];

const CoporateGovernance = () => {
  return (
    <>
      <div className="container py-4">
        <div className="row">
          <h1 className="text-center mb-4 display-6 fw-bold">
            Annual Return Forms
          </h1>

          {coporateDate.map((item, index) => (
            <div className="col-md-6 col-12" key={index}>
              <div
                className="card p-4 shadow-lg border-0 rounded-4 text-center"
                style={{ background: "#f9f9f9" }}
              >
                <h5 className="mt-3 fw-bold">{item.title}</h5>

                <a
                  href={item.img}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary mt-3 px-4 py-2 fw-semibold rounded-pill shadow-sm"
                  style={{
                    backgroundColor: "#15324A",
                    border: "none",
                    fontSize: "16px",
                    letterSpacing: "0.5px",
                  }}
                >
                  📄 View PDF
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CoporateGovernance;
